(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tax-status', {
            parent: 'entity',
            url: '/tax-status?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-status/tax-statuses.html',
                    controller: 'TaxStatusController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tax-status-detail', {
            parent: 'entity',
            url: '/tax-status/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.taxStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tax-status/tax-status-detail.html',
                    controller: 'TaxStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taxStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaxStatus', function($stateParams, TaxStatus) {
                    return TaxStatus.get({id : $stateParams.id});
                }]
            }
        })
        .state('tax-status.new', {
            parent: 'tax-status',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status/tax-status-dialog.html',
                    controller: 'TaxStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tax-status', null, { reload: true });
                }, function() {
                    $state.go('tax-status');
                });
            }]
        })
        .state('tax-status.edit', {
            parent: 'tax-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status/tax-status-dialog.html',
                    controller: 'TaxStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaxStatus', function(TaxStatus) {
                            return TaxStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tax-status.delete', {
            parent: 'tax-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tax-status/tax-status-delete-dialog.html',
                    controller: 'TaxStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaxStatus', function(TaxStatus) {
                            return TaxStatus.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('tax-status', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
